import React from "react";
import { reports, fmtDate } from "../../data/impactStories";
import { FileText, Download } from "lucide-react";
import { toast } from "sonner";

export default function RiReports() {
  return (
    <section id="reports" data-testid="ri-reports" className="py-24 lg:py-32 bg-[#0c0c0f] scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-accent mb-4">Reports &amp; Policies</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02]">
            The paperwork, <span className="text-amber-accent">beautifully kept.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reports.map((r, i) => (
            <div
              key={r.id}
              data-testid={`report-card-${r.id}`}
              className="reveal group relative rounded-2xl border border-white/8 bg-[#101014] p-7 overflow-hidden hover:border-[#F5D000]/50 transition-all"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 rounded-xl bg-[#F5D000]/10 border border-[#F5D000]/30 flex items-center justify-center group-hover:bg-[#F5D000] transition-colors">
                  <FileText className="w-5 h-5 text-[#F5D000] group-hover:text-black transition-colors" />
                </div>
                <span className="px-2.5 py-1 rounded-md border border-white/12 text-[10px] uppercase tracking-[0.18em] text-white/55">{r.category}</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-2 leading-snug">{r.title}</h3>

              {/* Hover reveal */}
              <div className="max-h-0 opacity-0 group-hover:max-h-56 group-hover:opacity-100 transition-all duration-500 overflow-hidden">
                <p className="text-sm text-white/65 leading-relaxed mb-4">{r.summary}</p>
                <div className="flex flex-wrap gap-x-5 gap-y-1 text-[11px] text-white/45 mb-4">
                  <span>{r.pages} pages</span>
                  <span>Published {fmtDate(r.published)}</span>
                  <span>{r.version}</span>
                </div>
              </div>

              <button
                data-testid={`report-download-${r.id}`}
                onClick={() => toast.info("Sample document, the final file will be published through the Impact Stories admin.")}
                className="mt-4 btn-ghost px-4 py-2.5 rounded-md text-xs font-semibold inline-flex items-center gap-2"
              >
                <Download className="w-3.5 h-3.5" /> Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
